import React, { useRef, useState, useMemo } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { uploadImage } from "../../../../../api/helper/upload-image";
import { useAddEvent } from "../../../../../api/inquiries/event/use-event";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import InputDate from "../../../../../components/ui/InputDate/InputDate";
import Modal from "../../../../../components/ui/Modal/Modal";
import Editor from "../../../../../components/Editor";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import { useEditor } from "../../../../../utils/hooks";

const EventRegisterPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const [eventStartDate, setEventStartDate] = React.useState(null);
  const [eventImage, setEventImage] = React.useState("");
  const [eventEndDate, setEventEndDate] = React.useState(null);
  const [selectedDateOption, setSelectedDateOption] = React.useState();
  const { mutate: addNotice } = useAddEvent();
  const quillRef = useRef(null);
  const [isContentsEmpty, setIsContentsEmpty] = useState(false);

  const formEmpty = useMemo(() => {
    return (
      title === "" ||
      eventStartDate === null ||
      eventEndDate === null ||
      isContentsEmpty
    );
  }, [title, eventStartDate, eventEndDate, isContentsEmpty]);

  const onTextChange = (content) => {
    setIsContentsEmpty(quillRef?.current?.getLength() === 1);
  };

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleSubmit = async () => {
    const payload = {
      title: title,
      contents: JSON.stringify(quillRef?.current?.getContents()),
      startDate: eventStartDate.toDate(),
      endDate: eventEndDate.toDate(),
      mainImg: eventImage,
    };
    await addNotice(payload);
  };

  const handleBack = () => {
    navigate("/bulletin-board");
  };
  const onChangeEventStartDate = (value) => {
    setEventStartDate(value);
  };

  const onChangeEventEndDate = (value) => {
    setEventEndDate(value);
  };
  const handleEventImageUpload = async (event) => {
    const file = event.target.files[0];

    const moreImageData = new FormData();
    moreImageData.append("file", file);

    const { data: image } = await uploadImage(moreImageData);

    setEventImage(image?.publicUrl);
  };

  const onChangeDateTo = (increment) => {
    if (eventStartDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const added = eventStartDate.add(increment, "day");
        setEventEndDate(added);
      }
      if (increment === 30) {
        const added = eventStartDate.add(1, "month");
        setEventEndDate(added);
      }
      if (increment === 90) {
        const added = eventStartDate.add(3, "month");
        setEventEndDate(added);
      }
    }
  };

  return (
    <>
      <div>
        <TitlePage title="이벤트 > 이벤트 등록 (ONEDAY Mall 이벤트)" />
        <div className="mt-4">
          <form>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox splitted label="이벤트 시작일">
                  <InputDate
                    value={eventStartDate}
                    onChange={onChangeEventStartDate}
                    defaultValue={eventStartDate}
                  />
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox splitted label="이벤트 종료일">
                  <div className="flex items-center gap-4">
                    <InputDate
                      value={eventEndDate}
                      onChange={onChangeEventEndDate}
                      defaultValue={eventEndDate}
                    />
                    <div
                      className={`border h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
                    >
                      <div
                        onClick={() => onChangeDateTo(1)}
                        className={`${
                          selectedDateOption === 1
                            ? "bg-primary-blue rounded-l-[4px] text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
                      >
                        오늘
                      </div>
                      <div
                        onClick={() => onChangeDateTo(7)}
                        className={`${
                          selectedDateOption === 7
                            ? "bg-primary-blue text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        7일
                      </div>
                      <div
                        onClick={() => onChangeDateTo(30)}
                        className={`${
                          selectedDateOption === 30
                            ? "bg-primary-blue text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        1개월
                      </div>
                      <div
                        onClick={() => onChangeDateTo(90)}
                        className={`${
                          selectedDateOption === 90
                            ? "bg-primary-blue rounded-r-[4px] text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        3개월
                      </div>
                    </div>
                  </div>
                </FieldBox>
              </div>
            </div>
            <FieldBox label="이벤트 배너">
              <div className="flex flex-wrap items-center p-2 gap-4">
                <label htmlFor="moreImageInput" className="cursor-pointer">
                  <div
                    className={` w-[140px] h-[140px]  border border-[#cccccc]`}
                  >
                    <input
                      id="moreImageInput"
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleEventImageUpload}
                    />
                    <AiOutlinePlus
                      className="text-[#707070] m-auto my-auto h-full"
                      size={"40"}
                    />
                  </div>
                </label>
                {eventImage === "" ? (
                  <div className="bg-[#e7e6e6] w-[35%] h-[140px] flex items-center justify-center p-6 text-center">
                    미리보기 <br />※ ‘+’ 버튼을 눌러, 이벤트 배너를 추가/수정
                    가능합니다.
                  </div>
                ) : (
                  <div className="relative w-[35%] h-[140px] border border-[#cccccc]">
                    <img
                      src={eventImage}
                      className="object-cover w-full h-full"
                      alt="event"
                    />
                  </div>
                )}
              </div>
              <div className="mt-2 text-[#999999] text-[11px] md:text-[12px] lg:text-[13px]">
                ※ 이벤트 배너 권장 사이즈 : WEB(PC) 기준 570x220. APP은
                WEB(PC)기준으로 리사이징 됩니다.
              </div>
            </FieldBox>

            <FieldBox label="이벤트 제목">
              <input
                className="rounded-[4px] w-full text-[12px] p-2 focus:outline-none"
                placeholder="제목을 입력해주세요"
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox isLast label="이벤트 내용" padding="p-0">
              <Editor ref={quillRef} onTextChange={onTextChange} />
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button text="입력취소" />
              </Modal>
              <Modal
                description={
                  <span>
                    해당 이벤트를 등록하시겠습니까?
                    <br />
                    병원웹,앱에 이벤트 '진행중'으로 표시가 됩니다.
                    <br />
                    <br />
                    ■ 이벤트 종료 방법
                    <br />
                    이벤트가 종료될 경우, 병원웹/앱에 이벤트 종료로 표시가
                    됩니다.
                    <br />
                    이미 종료된 이벤트를 추후에 다시 활용할 경우, [수정]을
                    통하여 '이벤트
                    <br />
                    시작일'과 '이벤트 종료일'을 변경해주시면 다시 이벤트가
                    '진행중'으로
                    <br />
                    변경됩니다.
                  </span>
                }
                onSubmit={handleSubmit}
                submitText="이벤트 등록"
                maxWidth="max-w-[26rem]"
                padding="p-5"
                widthSubmitButton="w-20"
              >
                <Button
                  isDisabled={formEmpty}
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EventRegisterPage;
